// src/pages/fiscal/mdfe/CadastroFiscalCad.js
import React, { useEffect, useState } from 'react';

import Input from '../../../components/input/Input';
import InputCheck from '../../../components/input/InputCheck';
import Select from '../../../components/input/Select';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import { useMessage } from '../../../contexts/geral/MessageContext';
import { useYesNo } from '../../../contexts/geral/YesNoContext';
import { useTransporteFiscal } from '../../../contexts/fiscal/TransporteFiscalContext';
import ModalActions, { ModalActionButton } from '../../../components/modalForm/ModalActions';

const numeros = (valor) => String(valor ?? '').replace(/\D/g, '');

const CadastroFiscalCad = ({ show, onHide, tipo, titulo, Model, campos, initialRegistro, onSaveRegistro }) => {
  const contexto = useTransporteFiscal();
  const [registro, setRegistro] = useState(new Model());
  const { showMessage } = useMessage();
  const { showYesNo } = useYesNo();
  const novo = () => setRegistro(new Model({ filialId: 1 }));

  useEffect(() => {
    if (show) {
      setRegistro(new Model(initialRegistro || { filialId: 1 }));
      contexto.carregar(tipo, 1);
    }
  }, [show, tipo, initialRegistro]);

  const alterar = (nome, valor) => setRegistro((prev) => ({ ...prev, [nome]: valor }));

  const validar = () => {
    if (tipo === 'veiculos' && String(registro.placa).replace(/\W/g, '').length !== 7) return 'Informe uma placa válida.';
    if (tipo === 'condutores' && (!registro.nome.trim() || numeros(registro.cpf).length !== 11)) return 'Informe nome e CPF válidos.';
    if (tipo === 'seguradoras' && (!registro.nome.trim() || numeros(registro.cnpj).length !== 14)) return 'Informe nome e CNPJ válidos.';
    return '';
  };

  const salvar = async () => {
    const erro = validar();
    if (erro) return showMessage(erro, 'warning');
    const payload = {
      ...registro,
      placa: registro.placa?.replace(/[^a-zA-Z0-9]/g, '').toUpperCase(),
      renavam: numeros(registro.renavam),
      cpf: numeros(registro.cpf),
      cnpj: numeros(registro.cnpj),
    };
    const salvo = await contexto.salvar(tipo, payload);
    setRegistro(new Model(salvo));
    onSaveRegistro?.(salvo);
  };

  const inativar = async () => {
    if (!registro.id) return showMessage(`Selecione um ${titulo.toLowerCase()} para excluir.`, 'warning');
    if (await showYesNo(`Deseja excluir o ${titulo.toLowerCase()} selecionado?`)) {
      await contexto.inativar(tipo, registro.id);
      novo();
    }
  };

  const pesquisar = async () => {
    const funcoes = {
      veiculos: contexto.showVeiculoSearch,
      condutores: contexto.showCondutorSearch,
      seguradoras: contexto.showSeguradoraSearch,
    };
    const selecionado = await funcoes[tipo]();
    if (selecionado) setRegistro(new Model(selecionado));
  };

  return (
    <ModalContainer show={show} largura={tipo === 'veiculos' ? '900px' : '650px'} variant="cadastro" onHide={onHide}>
      <ModalHeader title={registro.id ? `Alterar ${titulo}` : `Novo ${titulo}`} onHide={onHide} />
      <ModalBody>
        <div className="d-flex flex-wrap gap-2">
          <Input label="Código" value={registro.id || ''} disabled size={90} btnBuscar={pesquisar} />
          {campos.map((campo) => campo.tipo === 'check' ? (
            <InputCheck key={campo.nome} id={`${tipo}-${campo.nome}`} label={campo.label} checked={registro[campo.nome]} onChange={(e) => alterar(campo.nome, e.target.checked)} />
          ) : campo.options ? (
            <Select key={campo.nome} label={campo.label} value={registro[campo.nome] ?? ''} onChange={(e) => alterar(campo.nome, Number(e.target.value))} size={campo.size} options={campo.options} />
          ) : (
            <Input key={campo.nome} label={campo.label} value={registro[campo.nome] ?? ''} type={campo.tipo} mask={campo.mask} maxLength={campo.maxLength} size={campo.size} onChange={(e) => alterar(campo.nome, campo.upper ? e.target.value.toUpperCase() : e.target.value)} />
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <ModalActions >
          <ModalActionButton type="button" className="btn btn-primary" disabled={contexto.loading} onClick={salvar} action="save">{contexto.loading ? 'Salvando...' : 'Salvar'} </ModalActionButton>
          <ModalActionButton type="button" className="btn btn-danger" disabled={!registro.id || !registro.ativo} onClick={inativar} action="delete">Excluir </ModalActionButton>
          <ModalActionButton type="button" className="btn btn-secondary" disabled={!registro.id} onClick={novo} action="new">Novo </ModalActionButton>
        </ModalActions>
      </ModalFooter>
    </ModalContainer>
  );
};

export default CadastroFiscalCad;
